import React, { Component } from "react";

import "./index.css";
import { BsyUtils } from "../../utils/Utils";
import { BsyWidget } from "../BsyWidget";
import { doGraffiti } from "../../utils/doGraffiti";

export default class BsyThumbList extends BsyWidget {
  static defaultProps = {
    files: [],
    hasTooltip: !0,
    hasPreview: !1,
    previewHeight: 450,
    previewWidth: 450,
    thumbSize: 32,
  };
  constructor(props) {
    super({
      baseCls: "bsy-thumb-list",
      ...props,
    });
    this.state = {
      files: props.files,
      hasTooltip: props.hasTooltip,
      hasPreview: props.hasPreview,
      previewHeight: props.previewHeight,
      previewWidth: props.previewWidth,
      dataId: props.dataId,
      formId: props.formId,
      is_file_down: props.is_file_down,
      check_image_exif: props.check_image_exif,
      online_edit: props.online_edit,
      appId: props.appId,
      noDownload: props.noDownload,
      thumbSize: props.thumbSize,
      widget: props.widget,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    this.setState({
      ...nextProps,
    });
  }

  previewFile = (data, index) => {
    // console.log(data)
    let that = this;
    const {
      files,
      dataId,
      formId,
      appId,
      noDownload,
      widget,
      is_file_down,
      check_image_exif,
      online_edit,
      value,
    } = this.state;
    new window.FX.FilePreview({
      fieldName: widget.name || widget.fileName,
      title: files.length === 1 ? data.name : (widget.title || widget.text),
      files: files,
      widgetType: "image",
      noDownload: noDownload,
      is_file_down: is_file_down,
      check_image_exif: check_image_exif,
      currentItem: index,
      online_edit: online_edit,
      appId: appId,
      dataId: dataId,
      formId: formId,
      autoClose: !1,
      saveValue: (i) => {
        BsyUtils.applyFunc(that, that.options.onStopEdit, [i], !1);
      },
    });
  };

  previewImg = (e, url) => {
    let that = this;
    const { hasPreview, previewHeight, previewWidth } = this.state;
    if (!hasPreview) {
      return;
    }
    if (!url) {
      this.floatLayout = document.querySelectorAll(".bsy-float-preview-img");

      if (this.floatLayout) {
        for (let index = 0; index < this.floatLayout.length; index++) {
          const element = this.floatLayout[index];
          if (element) {
            element.remove();
          }
        }
      }
      this.floatLayout = null;
      return;
    }
    let width = previewWidth;
    let height = previewHeight;
    if (!this.floatLayout) {
      this.floatLayout = document.createElement("div");
      this.floatLayout.classList.add("bsy-float-preview-img");
      document.body.appendChild(this.floatLayout);
      resize("hidden");
      var image = new Image(); //创建一个image对象
      image.src = url; //新创建的image添加src
      image.onload = function () {
        // console.log(this.naturalWidth,this.naturalHeight)
        width = this.naturalWidth;
        if (width > previewWidth) {
          width = previewWidth;
        }
        height = this.naturalHeight;
        if (height > previewHeight) {
          height = previewHeight;
        }
        resize("");
      };
      this.floatLayout.appendChild(image);
    }

    function resize(display, image) {
      if (!that.floatLayout) return;

      const { top, left } = BsyUtils.elemoffset(e.target);
      height = that.floatLayout.offsetHeight;
      // console.log(top, left)
      // console.log(height)
      // console.log(that.floatLayout.offsetHeight);

      let css = {
        width: width + "px",
      };

      if (height > top) {
        //底部有足够的空间
        css.top = 0 + "px";
      } else {
        css.top = top - height - 26 + "px";
      }

      // else {
      //     css.bottom = document.documentElement.clientHeight - top + 2 + 'px'
      // }

      if (
        width > left ||
        document.documentElement.clientWidth - left - 10 > width
      ) {
        //右边有足够的空间
        css.left = left + e.target.offsetWidth + 10 + "px";
      } else {
        css.left = left - width - 10 + "px";
      }

      // console.log(css)
      that.floatLayout.style.zIndex = window.FX.STATIC.zIndex++;
      that.floatLayout.style.left = css.left;
      that.floatLayout.style.maxWidth = previewWidth + "px";
      that.floatLayout.style.maxHeight = previewHeight + "px";
      that.floatLayout.style.bottom = css.bottom ? css.bottom : "auto";
      that.floatLayout.style.top = css.top ? css.top : "auto";
      that.floatLayout.style.visibility = display;
    }
  };

  render() {
    const { files, hasTooltip, previewHeight, previewWidth, thumbSize } =
      this.state;

    return (
      <div className={"bsy-thumb-list"}>
        <div className="thumb-list">
          {BsyUtils.isArray(files) &&
            files.map((data, index) => {
              if (data.error) {
                return "";
              }

              var o = data.name ? data.name.split(".").pop() : "";

              return (
                <div
                  key={index}
                  className="thumb-item"
                  onClick={(e) => {
                    e.stopPropagation();
                    this.previewImg(e);
                    this.previewFile(data, index);
                  }}
                >
                  {BsyUtils.isImageExt(o) || data.imageUrl ? (
                    <img
                      onMouseEnter={(e) => {
                        e.stopPropagation();
                        this.previewImg(
                          e,
                          data.imageUrl
                            ? data.imageUrl
                            : BsyUtils.getfiledownloadURL(data, {
                              mode: 2,
                              width: previewWidth,
                              height: previewHeight,
                            })
                        );
                      }}
                      onMouseLeave={(e) => {
                        e.stopPropagation();
                        this.previewImg(e);
                      }}
                      title={hasTooltip ? data.name : ""}
                      alt={""}
                      src={
                        data.imageUrl
                          ? data.imageUrl
                          : BsyUtils.getfiledownloadURL(data, {
                            mode: 2,
                            width: thumbSize,
                            height: thumbSize,
                          })
                      }
                    />
                  ) : (
                    BsyUtils.createFileThumb(o, "tiny", data.name)
                  )}
                </div>
              );
            })}
        </div>
      </div>
    );
  }
}
